export const HANDLER_GET_COURTS = 'courts';
export const HANDLER_SUBMIT_DOC = 'submit';
export const HANDLER_REVIEW_DOC = 'review';
export const HANDLER_DECIDE_DOC = 'decide';
export const HANDLER_SERVICE_DOC = 'service';
export const HANDLER_COMPLETE_DOC = 'decide';
